import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router';
import useAuth from '../../hooks/useAuth';
import Navbar from '../Shared/Navbar/Navbar';

const Order = () => {
    const { register, handleSubmit, reset } = useForm();
    const [orderInfo, setOrderInfo] = useState({});
    const [alert, setAlert] = useState(false);
    const { user } = useAuth();
    const onSubmit = data => {
        setOrderInfo(data);
        fetch('https://infinite-river-22082.herokuapp.com/orders', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(orderInfo)
        })
            .then(res => res.json())
            .then(data => {
                if (data.insertedId) {
                    setAlert(true);
                    console.log(orderInfo);
                }
            })
        reset();
    };
    const { carname } = useParams();
    return (
        <>
            <Navbar />
            <div className='container'>
                <h2 className='text-center title mt-4'>Order Here for <span style={{ color: 'blueviolet' }}>{carname} 🔥</span></h2>

                <form className='text-center m-4' onSubmit={handleSubmit(onSubmit)}>
                    <label style={{ color: 'blueviolet', fontFamily: 'Poppins', fontWeight: 700 }} htmlFor="">Car Name: </label>
                    <input style={{ fontFamily: 'Poppins' }} className='m-3' {...register("carName")} value={carname} />
                    <br />
                    <label style={{ color: 'blueviolet', fontFamily: 'Poppins', fontWeight: 700 }} htmlFor="">User Name: </label>
                    <input style={{ fontFamily: 'Poppins' }} className='m-3' {...register("userName")} defaultValue={user.displayName} />
                    <br />
                    <label style={{ color: 'blueviolet', fontFamily: 'Poppins', fontWeight: 700 }} htmlFor="">User Email: </label>
                    <input style={{ fontFamily: 'Poppins' }} className='m-3' {...register("email")} value={user.email} />
                    <br />
                    <label style={{ color: 'blueviolet', fontFamily: 'Poppins', fontWeight: 700 }} htmlFor="">User Address: </label>
                    <input style={{ fontFamily: 'Poppins' }} className='m-3' {...register("address")} placeholder='Address' />
                    <br />
                    <label style={{ color: 'blueviolet', fontFamily: 'Poppins', fontWeight: 700 }} htmlFor="">User Phone: </label>
                    <input style={{ fontFamily: 'Poppins' }} className='m-3' type="number" {...register("phone")} placeholder='Phone Number' />
                    <br />
                    <input style={{ fontFamily: 'Poppins', backgroundColor: 'black', color: 'white', padding: '10px', border: 'none', borderRadius: '10px' }} className='m-3' type="submit" value='PLACE ORDER 🚀' />
                </form>
                {
                    alert && <div className="alert w-50 alert-success container" role="alert">
                        <h5 className='text-center' style={{ fontFamily: 'Poppins' }}>Order Placed! ✅</h5>
                    </div>
                }
            </div>
        </>
    );
};

export default Order;